import React from 'react';
import { arrayOf, objectOf, array, string, func } from 'prop-types';
import Section from './partials/Section';
import { dateToString, timeToShortString } from '../../utils/dates';

export default class Files extends React.Component {
    constructor(props) {
        super(props);
        this.renderItem = this.renderItem.bind(this);
    }

    popupFileCategories = ['Docket Attachments'];

    formatDateTime(dateString) {
        const date = new Date(dateString);
        return `${dateToString(date)}, ${timeToShortString(date)}`;
    }

    renderItem(item, key) {
        if (this.popupFileCategories.includes(item.FileCategory)) {
            return (
                <tr key={item.FileLocation}>
                    <td>
                        <button
                            href="#"
                            onClick={() => this.props.showCarousel(key, item.FileCategory)}
                            onKeyPress={() => this.props.showCarousel(key, item.FileCategory)}
                        >
                            {item.Filename}
                        </button>
                    </td>
                    {/* <td>{item.Filesize}</td>
                    <td>{this.formatDateTime(item.DateCreated)}</td> */}
                </tr>
            );
        }
        return (
            <tr key={item.FileLocation}>
                <td>
                    <a href={item.FileLocation} target="_blank" rel="noopener noreferrer">
                        {item.Filename}
                    </a>
                </td>
                {/* <td>{item.Filesize}</td>
                <td>{this.formatDateTime(item.DateCreated)}</td> */}
            </tr>
        );
    }

    render() {
        if (this.props.categories.length === 0) {
            return <div className="edocket-tab-files">Nothing to show</div>;
        }

        return (
            <div className="edocket-tab-files">
                {this.props.categories.map(category => (
                    <Section caption={category} key={category}>
                        <table className="edocket-tabs-data-table">
                            {/* <thead>
                                <tr>
                                    <th className="priority-width">File name</th>
                                    <th>File size</th>
                                    <th>Created</th>
                                </tr>
                            </thead> */}
                            <tbody>
                                {this.props.categorizedFiles[category].map(this.renderItem)}
                            </tbody>
                        </table>
                    </Section>
                ))}
            </div>
        );
    }
}

Files.propTypes = {
    categories: arrayOf(string).isRequired,
    categorizedFiles: objectOf(array).isRequired,
    showCarousel: func.isRequired
};
